import React, { useEffect, useRef, useState, useMemo, useCallback, useContext } from 'react';
import { apiHolder as api, apis, } from 'api';
import moment from 'moment';
import MailContent from './MailContent';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { formatFileSize } from '@web-common/utils/file';
import { getTrackedUrl } from '@web-common/utils/download_track';
import { useAppSelector } from '@web-common/state/createStore';
import { isMainAccount, systemIsWindow } from '../../../util';
const systemApi = api.api.getSystemApi();
const inElectron = systemApi.isElectron();
const fileApi = api.api.getFileApi();
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
import { useDebounceEffect } from 'ahooks';
import { getIn18Text } from 'api';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import useStateRef from '@web-mail/hooks/useStateRef';
import { VScrollContent } from '../useFixedScrollBar';
const notExpired = (expireTime) => {
    return expireTime == null || expireTime === 0 || expireTime > Date.now();
};
const Content = (props, ref) => {
    var _a, _b, _c;
    const { content, merge, showWrap, isrcl, mailIdChangeRecord, readOnly = false, onIframeScroll, onIframeSizeChange, featureConfig, forceUpdate, freezeMouse, } = props;
    const [icsMail, setIcsMail] = useState(false);
    const [curAttachments, setCurAttachments] = useState([]);
    const [icsSuccess, setIcsSuccess] = useState(true);
    const [attachmentsZipPath, setAttachmentsZipPath] = useState('');
    const [downLoadIrrevocable, setDownLoadIrrevocable] = useState(false);
    const scrollToAttachments = useAppSelector(state => state.readMailReducer.scrollToAttachments);
    const replyRef = useRef(null);
    const [icsProps, setIcsProps] = useState({
        mid: '0',
        attachmentsIds: [],
        senderEmail: '',
        setIcsSuccess,
    });
    const attacthRef = useRef(null);
    const [totalSize, setTotalSize] = useState('');
    const setAttachmentsZipPathRef = useRef('');
    setAttachmentsZipPathRef.current = attachmentsZipPath;
    const fromLocalEml = useMemo(() => !!(content === null || content === void 0 ? void 0 : content.localFilePath), [content]);
    const isTpMail = useMemo(() => !!(content === null || content === void 0 ? void 0 : content.isTpMail), [content]);
    const isDecrypted = useMemo(() => !!(content === null || content === void 0 ? void 0 : content.isDecrypted), [content]);
    const isEncryptedMail = useMemo(() => !!(content === null || content === void 0 ? void 0 : content.isEncryptedMail), [content]);
    const contentRef = useStateRef(content);
    const isMainAcc = useMemo(() => {
        return isMainAccount(content === null || content === void 0 ? void 0 : content._account);
    }, [content]);
    const attactCardConfig = useMemo(() => {
        return featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig.attachCard;
    }, [featureConfig]);
    const attachmentInlinedKey = useMemo(() => {
        var _a, _b;
        if (content && ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.attachment)) {
            let key = '';
            (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.attachment.forEach(item => {
                key += (item === null || item === void 0 ? void 0 : item.inlined) + ',';
            });
            return key;
        }
        return '';
    }, [content]);
    useEffect(() => {
        var _a, _b;
        if ((scrollToAttachments === null || scrollToAttachments === void 0 ? void 0 : scrollToAttachments.mailId) && (scrollToAttachments === null || scrollToAttachments === void 0 ? void 0 : scrollToAttachments.mailId) === ((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.id)) {
            (_b = attacthRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
        }
    }, [scrollToAttachments]);
    useDebounceEffect(() => {
        if (!(content === null || content === void 0 ? void 0 : content.id)) {
            return;
        }
        fileApi.getAttachmentZipPath(content === null || content === void 0 ? void 0 : content.id).then(result => {
            if (result) {
                setAttachmentsZipPath(result);
            }
            else {
                setAttachmentsZipPath('');
            }
        });
    }, [content === null || content === void 0 ? void 0 : content.id], { wait: 500 });
    useEffect(() => {
        if (!content) {
            return;
        }
        const list = content.entry.attachment;
        if (list && list.length) {
            const filterList = list
                .filter(item => !item.inlined)
                .map(item => (Object.assign(Object.assign({}, item), { type: 'download', cloudAttachment: item.type === 'netfolder', downloadId: item.id + ';' + content.id, downloadContentId: content.id, size: item.fileSize, mailId: content.id, unDecrypted: content.isEncryptedMail && !content.isDecrypted })));
            if (content.isDecrypted) {
                setCurAttachments([]);
                setTimeout(() => {
                    setCurAttachments(() => {
                        if (icsSuccess) {
                            return filterList.filter(item => item.fileType !== 'ics');
                        }
                        return filterList;
                    });
                }, 200);
            }
            else {
                setCurAttachments(() => {
                    if (icsSuccess) {
                        return filterList.filter(item => item.fileType !== 'ics');
                    }
                    return filterList;
                });
            }
            const listSize = filterList
                .filter(item => item.fileType !== 'ics')
                .reduce((total, current) => {
                total += current.size;
                return total;
            }, 0);
            setTotalSize(listSize > 0 ? formatFileSize(listSize, 1024) : '');
        }
        else {
            setTotalSize('');
            setCurAttachments(data => {
                if (data && data.length == 0) {
                    return data;
                }
                return [];
            });
        }
    }, [icsSuccess, attachmentInlinedKey, content === null || content === void 0 ? void 0 : content.id, (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.attachment, content === null || content === void 0 ? void 0 : content.isDecrypted]);
    const dealAttachments = (list, downloadContentId, senderEmail) => {
        const icsList = list.filter(attachment => attachment.fileType === 'ics');
        const normalAttachCount = list.filter(e => e.fileType !== 'ics');
        let category;
        if (icsList.length) {
            setIcsProps({
                senderEmail,
                mid: downloadContentId,
                setIcsSuccess,
                attachmentsIds: icsList.map(item => item.id),
            });
            setIcsMail(true);
            setIcsSuccess(true);
            category = getIn18Text('DAIicsFU');
        }
        else {
            setIcsMail(false);
            category = normalAttachCount && normalAttachCount.length > 0 ? getIn18Text('DAIFEIics') : getIn18Text('BUDAIPUTONGFU');
        }
        trackApi.track('pcMail_view_mailDetailPage', { category });
    };
    const revolveDownloadReminder = (reminders) => {
        const manageReminders = reminders.map(item => {
            if (item.filePath) {
                const realFileName = window.electronLib.fsManage.getBaseName(item.filePath);
                if (realFileName) {
                    return Object.assign(Object.assign({}, item), { realFileName });
                }
            }
            return item;
        });
        systemApi.createWindowWithInitData('downloadReminder', {
            eventName: 'customNotification',
            eventData: {
                eventType: 'downloadReminder',
                reminders: manageReminders,
            },
        });
    };
    const handleReply = useCallback(() => {
        var _a;
        (_a = replyRef.current) === null || _a === void 0 ? void 0 : _a.update();
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (content && (content === null || content === void 0 ? void 0 : content.id) && (content === null || content === void 0 ? void 0 : content.entry)) {
            if ((_b = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.length) {
                dealAttachments((_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.attachment, content === null || content === void 0 ? void 0 : content.id, (_e = (_d = content === null || content === void 0 ? void 0 : content.sender) === null || _d === void 0 ? void 0 : _d.contactItem) === null || _e === void 0 ? void 0 : _e.contactItemVal);
            }
            else {
                setIcsMail(false);
                trackApi.track('pcMail_view_mailDetailPage', { category: getIn18Text('BUDAIPUTONGFU') || '' });
            }
        }
    }, [content === null || content === void 0 ? void 0 : content.id, (_c = (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.attachment) === null || _c === void 0 ? void 0 : _c.length, forceUpdate]);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const saveAttachmentZip = useCallback(async () => {
        var _a;
        const attachments = curAttachments.filter(attachment => notExpired(attachment.expired));
        if (attachments.length === 0) {
            return;
        }
        const currDayStr = moment().format('YYYYMMDD');
        let mailName = '-';
        try {
            const title = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.title;
            if (title) {
                mailName = title.replace(/[:*\^\|'"`~]/gi, '_');
            }
        }
        catch (e) {
            console.error('[Error reg]', e);
        }
        const zipFileName = isCorpMail
            ?
                `Attachments-${currDayStr}`
            : `${mailName}的全部附件${currDayStr}`;
        if (inElectron) {
            if (downLoadIrrevocable)
                return;
            setDownLoadIrrevocable(true);
            try {
                const zipRes = await fileApi.saveZip(attachments, zipFileName, content === null || content === void 0 ? void 0 : content.id, {
                    removeOrginalFile: true,
                    flowScene: 'mail_read',
                    _account: content === null || content === void 0 ? void 0 : content._account,
                });
                console.log('saveAttachmentZip 打包下载', zipRes);
                const { success, path } = zipRes;
                if (success && path) {
                    setAttachmentsZipPath(path);
                    try {
                        const zipData = await window.electronLib.fsManage.stat(path);
                        if (zipData) {
                            revolveDownloadReminder([
                                {
                                    fileName: `${zipFileName}.zip`,
                                    fileSize: zipData.size,
                                    fileType: 'zip',
                                    filePath: path,
                                },
                            ]);
                        }
                    }
                    catch (err) {
                        console.log('打包下载完成提醒失败', err);
                    }
                }
            }
            catch (e) {
                console.error(e);
                SiriusMessage.warn({ content: getIn18Text('DABAOXIAZAISHI') });
            }
            finally {
                setDownLoadIrrevocable(false);
            }
        }
        else {
            const url = mailConfApi.getReadMailPackUrl(content, attachments, zipFileName);
            if (url) {
                const trackedUrl = getTrackedUrl(url);
                window.open(trackedUrl || url);
            }
        }
    }, [isCorpMail, downLoadIrrevocable, content, curAttachments]);
    const saveAllAttachment = useCallback(async (_account) => {
        const attachments = curAttachments.filter(attachment => notExpired(attachment.expired));
        if (attachments.length === 0) {
            return;
        }
        if (downLoadIrrevocable) {
            return;
        }
        setDownLoadIrrevocable(true);
        try {
            const downloadRes = await fileApi.saveAll(attachments, _account);
            console.log('saveAllAttachment 分别下载', downloadRes);
            const { success, loadResArr } = downloadRes;
            if (success && loadResArr) {
                let sucFileModel = [];
                loadResArr.forEach(item => {
                    const { succ, fileModel } = item;
                    if (succ && (fileModel === null || fileModel === void 0 ? void 0 : fileModel.filePath)) {
                        sucFileModel.push(fileModel);
                    }
                });
                (sucFileModel === null || sucFileModel === void 0 ? void 0 : sucFileModel.length) && revolveDownloadReminder(sucFileModel);
            }
        }
        catch (e) {
            console.error(e);
            SiriusMessage.warn({ content: getIn18Text('FENBIEXIAZAISHI') });
        }
        finally {
            setDownLoadIrrevocable(false);
        }
    }, [isCorpMail, downLoadIrrevocable, content, curAttachments]);
    const openDir = useCallback(() => {
        const isSuccess = fileApi.openDir(setAttachmentsZipPathRef.current);
        if (!isSuccess) {
            SiriusMessage.warn({ content: getIn18Text('WEIZHAODAOWENJIAN11') }).then(() => {
                setAttachmentsZipPath('');
                fileApi.delAttachmentZipPath(content === null || content === void 0 ? void 0 : content.id);
            });
        }
    }, []);
    const iframeRef = useRef();
    React.useImperativeHandle(ref, () => ({
        getAttachRef: () => attacthRef,
        getIframeRef: () => iframeRef,
    }), [attacthRef, iframeRef.current]);
    const onIframeSizeChangeRef = useCreateCallbackForEvent(onIframeSizeChange);
    const MailContentEmement = useMemo(() => {
        return (React.createElement(MailContent, { merge: merge, icsMail: icsMail, icsProps: icsProps, content: content, handleReply: handleReply, ref: re => {
                if (re && re.getIframeRef) {
                    iframeRef.current = re.getIframeRef().current;
                }
            }, isrcl: isrcl, forceUpdate: forceUpdate, mailIdChangeRecord: mailIdChangeRecord, readOnly: readOnly, onIframeSizeChange: onIframeSizeChangeRef, onIframeScroll: onIframeScroll, freezeMouse: freezeMouse }));
    }, [merge, icsMail, icsProps, content, handleReply, isrcl, mailIdChangeRecord, readOnly, forceUpdate, freezeMouse]);
    const mergeMailStWrap = useMemo(() => {
        return systemIsWindow() ? 'merge-mail-scroll-wrap-inwin' : 'merge-mail-scroll-wrap';
    }, []);
    const { regiestIframe, unregisterIframe } = useContext(VScrollContent);
    useEffect(() => {
        regiestIframe(content === null || content === void 0 ? void 0 : content.id, iframeRef.current);
        return () => {
            unregisterIframe(content === null || content === void 0 ? void 0 : content.id);
        };
    }, [content === null || content === void 0 ? void 0 : content.id]);
    if (showWrap) {
        return (React.createElement("div", { className: `extheme ${mergeMailStWrap}`, style: { backgroundColor: '#fff' } }, MailContentEmement));
    }
    return (React.createElement("div", { className: "extheme", style: { backgroundColor: '#fff' } }, MailContentEmement));
};
export default React.forwardRef(Content);
